import useEvidonLib from "../hooks/useEvidonLib";
import isGDPR from "../helpers/isGDPR";
import EvidonSetConsentHotfix from "./EvidonSetConsentHotfix";
import EvidonGdprConsentHotfix from "./EvidonGdprConsentHotfix";
import EvidonBannerNavigationHotfix from "./EvidonBannerNavigationHotfix";

function Evidon() {
  const isEvidonLibReady = useEvidonLib();

  return isEvidonLibReady ? (
    <>
      <EvidonSetConsentHotfix />
      {isGDPR() ? (
        <>
          <EvidonGdprConsentHotfix />
          <EvidonBannerNavigationHotfix />
        </>
      ) : null}
    </>
  ) : null;
}

export default Evidon;
